<template>
  <div class="pages">
    <navTop></navTop>
    <div class="box">
      <li>
        <span>1、Photo of vessel (Non-must fill)</span>
        <img :src="dataList.ly001" />
      </li>
      <li>
        <span>2、Site phote of surveyor  (Non-must fill)</span>
        <img :src="dataList.ly002" />
      </li>
      <li>
        <span>3、Photos of inspect（Non-must fill）</span>
        <img :src="dataList.ly003" />
      </li>
      <li>
        <span>4、Report No.</span>
        <span>{{ dataList.ly004 }}</span>
      </li>
      <li>
        <span>5、Port</span>
        <span>{{ dataList.ly005 }}</span>
      </li>
      <li>
        <span>6、Berth</span>
        <span>{{ dataList.ly006 }}</span>
      </li>
      <li>
        <span>7、Shipowners Messrs.</span>
        <span>{{ dataList.ly007 }}</span>
      </li>
      <li>
        <span>8、First-up ship oil LSFO / HSFO (first oil)</span>
        <span>{{ dataList.ly008 }}</span>
      </li>
      <li>
        <span>9、Time to Deliver/Re-delivery the ship</span>
        <span>{{ dataList.ly009 }}</span>
      </li>
      <li>
        <span>10、Next Charterer name</span>
        <span>{{ dataList.ly010 }}</span>
      </li>
      <li>
        <span>11、Vessel name</span>
        <div style="color: #fff !important;margin-top: 10px;font-size: 24px;">{{ dataList.ly011 }}</div>
      </li>
      <li>
        <span>12、 Bunker Survey</span>
        <div style="color: #fff !important;margin-top: 10px;font-size: 24px;">{{dataList.ly012}}</div>

      </li>
      <li>
        <span>13、Survey Time (LT)</span>
        <div style="color: #fff !important;margin-top: 10px;font-size: 24px;">LMT：{{dataList.ly013}}</div>
        <div style="color: #fff !important;margin-top: 10px;font-size: 24px;">GMT：{{dataList.ly01301}}</div>
      </li>
      <li>
        <span>14、Call sign</span>
        <span>{{ dataList.ly014 }}</span>
      </li>
      <li>
        <span>15、Flag / Port of Registry</span>
        <span>{{ dataList.ly015 }}</span>
      </li>
      <li>
        <span>16、Year of Built / Place</span>
        <span>{{ dataList.ly016 }}</span>
      </li>
      <li>
        <span>17、GRT / NRT</span>
        <span>{{ dataList.ly017 }}</span>
      </li>
      <li>
        <span>18、LOA / BM</span>
        <span>{{ dataList.ly018 }}</span>
      </li>
      <li>
        <span>19、DWT (SUMMER)</span>
        <span>{{ dataList.ly019 }}</span>
      </li>
      <li>
        <span>20、Summer Draft</span>
        <span>{{ dataList.ly020 }}</span>
      </li>
      <li>
        <span>21、Holds/Hatches</span>
        <span>{{ dataList.ly021 }}</span>
      </li>
      <li>
        <span>22、Main engine</span>
        <span>{{ dataList.ly022 }}</span>
      </li>

      <li>
        <span>23、ROB</span>
        <div style="color: #fff !important;margin-top: 10px;font-size: 24px;">
          H.S  Fuel OIL：  {{ dataList.ly023 }}MT
        </div>
        <div style="color: #fff !important;margin-top: 10px;font-size: 24px;">
          L.S  Fuel Oil：  {{ dataList.ly02301 }}MT
        </div>
        <div style="color: #fff !important;margin-top: 10px;font-size: 24px;">
          Marine Diesel Oil：{{ dataList.ly02302 }}MT
        </div>
        <div style="color: #fff !important;margin-top: 10px;font-size: 24px;">
          Marine Gas Oil ：   {{ dataList.ly02303 }}MT
        </div>

      </li>
      <li>
        <span>24、Date & Time of Completion of Bunker Survey</span>
        <span>{{ dataList.ly024 }}</span>
      </li>
      <li>
        <span>25、Bunker Survey Calculate Sheet Printscreen</span>
        <div class="imgs" v-if="dataList.ly025"><img :src="item" v-for="(item, index) in dataList.ly025.split('|')" /></div>
      </li>
      <li>
        <span>26、Delivery Time (LT)</span>
        <div style="color: #fff !important;margin-top: 10px;font-size: 24px;">
          LMT：{{ dataList.ly026 }}
        </div>
        <div style="color: #fff !important;margin-top: 10px;font-size: 24px;">
          GMT：{{ dataList.ly02601 }}
        </div>

      </li>


      <li>
        <span>28、Place of Deliver/Re-delivery </span>
        <div style="color: #fff !important;margin-top: 10px;font-size: 24px;">
          LMT：{{ dataList.ly028 }}
        </div>
        <div style="color: #fff !important;margin-top: 10px;font-size: 24px;">
          GMT：{{ dataList.ly02801 }}
        </div>
      </li>
      <li>
        <span>29、Ship's Particular</span>
        <div class="imgs" v-if="dataList.ly029"><img :src="item" v-for="(item, index) in dataList.ly029.split('|')" /></div>
      </li>
      <li>
        <span>30、Bunker Survey Tables</span>
        <div class="imgs" v-if="dataList.ly030"><img :src="item" v-for="(item, index) in dataList.ly030.split('|')" /></div>
      </li>
      <li>
        <span>31、 Certificate of Bunker Quantity </span>
        <div class="imgs" v-if="dataList.ly031"><img :src="item" v-for="(item, index) in dataList.ly031.split('|')" /></div>
      </li>
      <li>
        <span>32、Certificate of On/Off Hire Bunker Quantity </span>
        <div class="imgs" v-if="dataList.ly032"><img :src="item" v-for="(item, index) in dataList.ly032.split('|')" /></div>
      </li>
      <li>
        <span>35、Confimation Letter of Ship's Condition at Delivery/Re-delivery </span>
        <div class="imgs" v-if="dataList.ly035"><img :src="item" v-for="(item, index) in dataList.ly035.split('|')" /></div>
      </li>
      <li>
        <span>36、Photograph </span>
        <div class="imgs" v-if="dataList.ly036"><img :src="item" v-for="(item, index) in dataList.ly036.split('|')" /></div>
      </li>
      <li>
        <span>37、Charterers Messrs</span>
        <span>{{ dataList.ly037 }}</span>
      </li>
      <li>
        <span>38、Signature of inspector</span>
        <div class="imgs" v-if="dataList.ly038">
          <img style="background: #fff;" :src="item" v-for="(item, index) in dataList.ly038.split('|')" />
        </div>
      </li>
      <li>
        <span>39、Description of ship condition</span>
        <p style="color: #fff;">
          GENERAL INFORMATION
        </p>
        <p style="color: #fff;">
          <p style="color: #fff;">The vessel's condition was inspectedin berthinc</p>
          <p style="color: #fff;">
            status.while the bunker was sounded and calculated with draft Fore:{{ dataList.ly039 }} M Aft:{{ dataList.ly03901 }} M and with {{ dataList.ly03902 }} list MV"{{ dataList.ly03903 }}"(Enter:Vesselnameisa {{ dataList.ly03904 }}(Enter:Type of vessel). built in {{ dataList.ly03905 }} (Enter:Year ofBuilt/Placesingle screw. raked stem with bulbous bowtransomstern and superstructure at aft wheretheaccommodation. navigating bridge and the machinery space are located The vessel cargo compartment is divided into {{ dataList.ly03906 }} (Enter:Quantity of hatch cover) hatches {{ dataList.ly03907 }} (Enter:Quantity of cargo hold) holds.
          </p>
          <p style="color: #fff;">
            Steel hatch covers were side rolling type and opened closed by hydraulic systemTopside tanks are provided forballast and bunkers.
          </p>
          <p style="color: #fff;">
            We were given that she will redeliver from {{ dataList.ly03908 }} to {{ dataList.ly03909 }} at place of {{ dataList.ly03910 }} (Enter:Place of Re-delivery)
          </p>
          <p style="color: #fff;">
            Our inspections onboardincluding internal inspections in the cargo compartmentswere made withthe
            weather deck hatch covers in {{ dataList.ly03911 }} conditionand in {{ dataList.ly03912 }}
          </p>
          <p style="color: #fff;">
            Each of the {{ dataList.ly03913 }} Enter:Quantity of cargoholdcargo holds was fitted with a access ladder at oneend and {{ dataList.ly03914 }} ladder sections at the other.
          </p>

        </p>
        <p style="color: #fff;margin-top: 20px;">
          <p style="color: #fff;">A)Weather Decks and Structures:</p>
          <p style="color: #fff;">
            Scale Rating: {{dataList.ly039a01}} condition

            Our Examination of the vessel's weather Decks and structures.inclusive of the weather Deckhatch covers and coamings,revealed {{dataList.ly039a02}} structural conditions in {{dataList.ly039a03}} condition.The hydraulic pipes on the main Deck were in wellconditionair pipesfilling pipes
            watertight doors,pilot ladders,fairleader mooring bitts gangway and winches in apparent {{dataList.ly039a04}} condition.The accommodation ladders were in {{dataList.ly039a05}} condition The handrail on both side of main Deck was in {{dataList.ly039a06}} condition.
          </p>
          <p style="color: #fff;">
            Remarks:{{dataList.ly039a07}}
          </p>
          <p style="color: #fff;margin-top: 20px;">
            <p style="color: #fff;">B) Hull:</p>
            <p style="color: #fff;">
              Scale Rating: {{dataList.ly039b01}} condition:
            </p>
            <p style="color: #fff;">The Hull plate under &above the waterline was in {{dataList.ly039b02}} condition </p>
            <p style="color: #fff;">
              Remarks:{{dataList.ly039b03}}
            </p>
          </p>

          <p style="color: #fff;margin-top: 20px;">
            <p style="color: #fff;">C) Hatch cover & Cargo Hold Internals:</p>
            <p style="color: #fff;">
              Scale Rating:{{dataList.ly039c01}}
            </p>
            <p style="color: #fff;">
              There was no evidence of any significant water leakage or intrusion into the cargo holds.Hold divisional bulkheads are in {{dataList.ly039c02}} condition.
            </p>
            <p style="color: #fff;">
              The coatings/paint in holds {{dataList.ly039c03}} (Enter: cargo hold No.) were in {{dataList.ly039c04}} condition These were considered {{dataList.ly039c05}} wear and tear with the exceptions noted here below.
            </p>
            <p style="color: #fff;">
              Remarks:{{dataList.ly039c06}}
            </p>
      </li>
      <li>
        <div style="margin-top: 20px;" v-for="(item,index) in dataList.atScheduleNewLy039cList">
          <p style="color: #fff;">
            {{item.name}} Hold
          </p>
          <p style="color: #fff;">
            Forecastle:
          </p>
          <p style="color: #fff;">
            The forecastle against the enclose bulk head of forecastle store which is {{item.ly039c101}} maintained and apparently serviceable in case.
          </p>
          <p style="color: #fff;">Hatch cover panel top plating&underside:</p>
          <p style="color: #fff;">
            Coating maintained in {{item.ly039c102}} condition, {{item.ly039c103}} discernible damaged noted.Longitudinal guttering and hatch rims were free of any physical damages
          </p>
          <p style="color: #fff;">
            Hatch coaming top:
          </p>
          <p style="color: #fff;">
            Hatch coamings top compress bars in {{item.ly039c104}} condition, {{item.ly039c105}} of rust scale or any deformation.
            Wheel tracks were free of loose scale and unobstructed
          </p>
          <p style="color: #fff;">
            Drain channel:
          </p>
          <p style="color: #fff;">
            Coaming drain channels and drain holes were
            unobstructed.The non-return valves were found in {{item.ly039c106}} condition.
          </p>
          <p style="color: #fff;">
            Rubber gasket of hatch covers & hold access:
          </p>
          <p style="color: #fff;">
            In {{item.ly039c107}} condition.
          </p>
          <p style="color: #fff;">
            Hydraulic system of hatch cover:
          </p>
          <p style="color: #fff;">
            Hydraulic system functioning operated were in apparently {{item.ly039c108}} conditionthere were no leaking of oil from joint connections or hoses.
          </p>
          <p style="color: #fff;">
            After Bulkhead:
          </p>
          <p style="color: #fff;">
            In {{item.ly039c109}} condition, partly rustedscratched in places and pitted at spots and air pipes &their protective bars were in {{item.ly039c110}} condition, access ladder fixed and found in {{item.ly039c111}} condition.
          </p>
          <p style="color: #fff;">
            Stbd Side:
          </p>
          <p style="color: #fff;">
            In {{item.ly039c112}} condition, partly rusted, scratched in places and concaved several areas.
          </p>
          <p style="color: #fff;">
            Fwd. Bulkhead:
          </p>
          <p style="color: #fff;">
            In {{item.ly039c113}} condition, straight accesses ladder fixed and found the vertical platform in {{item.ly039c114}} condition.
          </p>
          <p style="color: #fff;">
            Port Side:
          </p>
          <p style="color: #fff;">
            In {{item.ly039c115}} condition.
          </p>
          <p style="color: #fff;">
            {{item.ly039c116}} rusted and scratched in places.
          </p>
          <p style="color: #fff;">
            Tank Top Plating:
          </p>
          <p style="color: #fff;">
            There were {{item.ly039c117}} discernible damages in way of the tank top plating.
          </p>
          <p style="color: #fff;">
            Inner Hatch Coamings:
          </p>
          <p style="color: #fff;">
            Maintained in {{item.ly039c118}} condition.
          </p>
          <p style="color: #fff;">
            Ladders and platforms:
          </p>
          <p style="color: #fff;">
            The fore and aft guardrail of the ladder in {{item.ly039c119}} condition.
          </p>
          <p style="color: #fff;">
            Remarks:{{item.ly039c120}}
          </p>
        </div>
      </li>

      <li v-if="dataList.ly040 && dataList.ly040.split('|').length>0">
        <span>40、Video</span>
        <div class="imgs">
          <video :src="item" @click="togglePlayback(item)" width="100px" height="100px" style="margin-right: 10px" :key="index" v-for="(item, index) in dataList.ly040.split('|')" />
        </div>
      </li>

      <li v-if="dataList.ly041 && dataList.ly041.split('|').length>0">
        <span>41、Photo</span>
        <div class="imgs">
          <img style="background: #fff;" :src="item" v-for="(item, index) in dataList.ly041.split('|')" />
        </div>
      </li>
    </div>
    <navFooter></navFooter>
    <el-dialog
        title="视频"
        size="small"
        v-dialogDrag
        :visible.sync="isVisible"
        :before-close="handleClose">
      <div class="video-player">
        <!-- 视频元素 -->
        <video
            ref="videoPlayer"
            :src="videoSrc"
            style="width: 100%;height: auto;display: block;"
            @timeupdate="updateProgress"
            @play="onPlay"
            @pause="onPause"
            @loadedmetadata="onLoadedMetadata"/>

        <!-- 控制栏 -->
        <div class="controls">
          <!-- 播放/暂停按钮 -->
          <button @click="togglePlayPause" class="control-btn">
            <img v-if="!isPlaying" src="../../assets/stop_icon.png" style="width: 30px;height: 30px;"/>
            <img v-if="isPlaying" src="../../assets/start_icon.png" style="width: 30px;height: 30px;"/>
          </button>

          <!-- 进度条 -->
          <div class="progress-bar" @click="seekToTime">
            <div class="progress" :style="{ width: progress + '%' }"></div>
          </div>

          <!-- 时间显示 -->
          <span class="time">{{ currentTime }} / {{ duration }}</span>

          <!-- 全屏按钮 -->
          <button @click="toggleFullScreen" class="control-btn">
            <i class="fas fa-expand"></i>
          </button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import navTop from '../../components/navTop.vue';
import navFooter from '../../components/navFooter.vue';
import pdf from 'vue-pdf';
export default {
  name: 'ly',
  components: {
    navTop,
    navFooter,
    pdf
  },
  data() {
    return {
      dataList: {},
      num: '',
      isVisible: false, // 控制播放状态

      videoSrc: '', // 视频URL
      isPlaying: false, // 是否正在播放
      progress: 0, // 播放进度
      currentTime: '00:00', // 当前播放时间
      duration: '00:00', // 视频总时长
      videoList:[]
    };
  },
  created() {
    if (!sessionStorage.getItem('uid')) {
      this.$router.push({ path: '/' });
    } else {
      this.id = this.$route.query.id;
      this.getSchedulely();
    }
  },
  methods: {
    getSchedulely() {
      let data = {
        id: this.id
      };
      this.$api.schedulely(data).then(res => {
        console.log(res);
        if (res.result == 0) {
          this.dataList = res.data;
          if (res.data.ly026) {
            if (this.getSuffix(res.data.ly026) == 'pdf') {
              this.num = 1;
            } else {
              this.num = 0;
            }
          }


        }
      });
    },

    getLyVideo(){
      this.$http({
        url: `/at/order/atOrder/getLyDetail?id=${this.inputForm.id}`,
        method: 'get'
      }).then(({data}) => {
        if(data.lyDetail){
          data.lyDetail.split('|').forEach((item) => {
            if (item.trim().length > 0) {
              this.videoList.push(item);
            }
          })
        }
      })
    },
    getJyVideo(){
      this.$http({
        url: `/at/order/atOrder/getJyDetail?id=${this.inputForm.id}`,
        method: 'get'
      }).then(({data}) => {
        if(data.jyDetail){
          data.jyDetail.split('|').forEach((item) => {
            if (item.trim().length > 0) {
              this.videoList.push(item);
            }
          })
        }
      })
    },
    // 截取后缀名
    getSuffix(str) {
      var index = str.lastIndexOf('.');
      return str.substr(index + 1);
    },
    togglePlayback(item){
      this.videoSrc=item
      this.isVisible=true
    },

    // 切换播放/暂停
    togglePlayPause() {
      const video = this.$refs.videoPlayer;
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    },

    // 更新播放进度
    updateProgress() {
      const video = this.$refs.videoPlayer;
      this.progress = (video.currentTime / video.duration) * 100; // 计算进度百分比
      this.currentTime = this.formatTime(video.currentTime); // 格式化当前时间
    },

    // 跳转到指定时间
    seekToTime(event) {
      const video = this.$refs.videoPlayer;
      const progressBar = event.currentTarget;
      const clickPosition = event.offsetX; // 获取点击位置
      const progressBarWidth = progressBar.clientWidth; // 获取进度条宽度
      const seekTime = (clickPosition / progressBarWidth) * video.duration; // 计算跳转时间
      video.currentTime = seekTime;
    },

    // 播放事件
    onPlay() {
      this.isPlaying = true;
    },

    // 暂停事件
    onPause() {
      this.isPlaying = false;
    },

    // 视频元数据加载完成
    onLoadedMetadata() {
      const video = this.$refs.videoPlayer;
      this.duration = this.formatTime(video.duration); // 初始化总时长
    },

    // 切换全屏
    toggleFullScreen() {
      const video = this.$refs.videoPlayer;
      if (!document.fullscreenElement) {
        if (video.requestFullscreen) {
          video.requestFullscreen();
        } else if (video.mozRequestFullScreen) {
          video.mozRequestFullScreen();
        } else if (video.webkitRequestFullscreen) {
          video.webkitRequestFullscreen();
        } else if (video.msRequestFullscreen) {
          video.msRequestFullscreen();
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        }
      }
    },

    // 格式化时间（秒 -> MM:SS）
    formatTime(time) {
      const minutes = Math.floor(time / 60);
      const seconds = Math.floor(time % 60);
      return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    },
    handleClose(){
      if (this.$refs.videoPlayer) {
        this.$refs.videoPlayer.pause();
      }
      this.isVisible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
// 科技蓝色风格变量 - 使用 #1ba8e8 作为主色调
$blue-primary: #1ba8e8;
$blue-primary-rgba: rgba(27, 168, 232, 0.9);
$blue-secondary: #4ab9f0;
$blue-glow: rgba(27, 168, 232, 0.4);
$blue-light: rgba(27, 168, 232, 0.2);
$blue-dark: #0f2b3f;
$text-glow: 0 0 8px rgba(27, 168, 232, 0.5);

.pages {
  background: linear-gradient(135deg, #0f2b3f 0%, #1a3f5a 100%);
  position: relative;
  min-height: 10vh;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 20% 30%, rgba(27, 168, 232, 0.1) 0%, transparent 50%);
    pointer-events: none;
  }

  .box {
    max-width: 1400px;
    margin: 30px auto 80px;
    padding: 0 20px;
    position: relative;
    z-index: 2;

    border: 1px solid $blue-primary-rgba;
    border-radius: 20px;
    padding: 40px 60px;
    box-sizing: border-box;
    background: rgba(15, 43, 63, 0.6);
    backdrop-filter: blur(10px);
    box-shadow: 0 0 40px $blue-glow;

    li {
      display: flex;
      flex-direction: column;
      padding-bottom: 30px;
      margin-bottom: 20px;
      border-bottom: 1px dashed $blue-primary-rgba;
      box-sizing: border-box;

      &:last-child {
        border-bottom: none;
        padding-bottom: 0;
        margin-bottom: 0;
      }

      span:nth-child(1) {
        color: $blue-primary;
        font-size: 20px;
        line-height: 1.2em;
        font-weight: 500;
        text-shadow: $text-glow;
      }

      span:nth-child(2) {
        font-size: 18px;
        color: #c0e4ff;
        line-height: 1.3em;
        padding-top: 10px;
        box-sizing: border-box;
        word-break: break-word;
      }

      a {
        font-size: 18px;
        color: #c0e4ff;
        line-height: 1.3em;
        padding-top: 10px;
        box-sizing: border-box;
        word-break: break-word;
        text-decoration: none;
        transition: all 0.3s ease;

        &:hover {
          color: $blue-primary;
          text-shadow: $text-glow;
        }
      }

      img {
        margin-top: 15px;
        display: block;
        width: 100%;
        max-width: 392px;
        height: auto;
        max-height: 292px;
        border-radius: 10px;
        border: 2px solid $blue-primary;
        box-shadow: 0 0 20px $blue-glow;
        object-fit: cover;
      }

      .imgs {
        display: flex;
        flex-wrap: wrap;
        gap: 15px;
        margin-top: 15px;

        img {
          width: 200px;
          height: 150px;
          margin-top: 0;
          object-fit: cover;

          &:hover {
            transform: scale(1.02);
            box-shadow: 0 0 30px $blue-primary;
          }
        }
      }

      video {
        cursor: pointer;
        transition: all 0.3s ease;

        &:hover {
          transform: scale(1.02);
          box-shadow: 0 0 30px $blue-primary;
        }
      }
    }
  }
}

.video-player {
  max-width: 100%;
  margin: 0 auto;
  position: relative;
  background: #000;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid $blue-primary;
  box-shadow: 0 0 30px $blue-glow;
}

.controls {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(15, 43, 63, 0.9);
  backdrop-filter: blur(5px);
  padding: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
  border-top: 1px solid $blue-primary-rgba;
}

.control-btn {
  background: none;
  border: none;
  color: $blue-primary;
  font-size: 20px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.1);
    text-shadow: $text-glow;
  }
}

.progress-bar {
  flex: 1;
  height: 5px;
  background: rgba(27, 168, 232, 0.2);
  position: relative;
  cursor: pointer;
  border-radius: 3px;
  overflow: hidden;
}

.progress {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: $blue-primary;
  box-shadow: 0 0 10px $blue-primary;
}

.time {
  color: #c0e4ff;
  font-size: 14px;
  text-shadow: 0 0 5px $blue-glow;
}

::v-deep .el-dialog {
  background: linear-gradient(135deg, #0f2b3f 0%, #1a3f5a 100%);
  border: 1px solid $blue-primary;
  border-radius: 10px;
  box-shadow: 0 0 40px $blue-glow;

  .el-dialog__title {
    color: $blue-primary;
    text-shadow: $text-glow;
  }

  .el-dialog__header {
    border-bottom: 1px solid $blue-primary-rgba;
  }

  .el-dialog__headerbtn .el-dialog__close {
    color: $blue-primary;

    &:hover {
      color: lighten($blue-primary, 20%);
    }
  }

  .el-dialog__body {
    padding: 20px;
  }
}

// 底部样式
::v-deep .footer {
  background: linear-gradient(90deg, #0f2b3f 0%, #1a3f5a 100%) !important;
  border-top: 2px solid $blue-primary !important;
  box-shadow: 0 -5px 25px $blue-glow !important;
  position: relative;
  z-index: 2;

  .footer-left {
    .logo {
      filter: drop-shadow(0 0 10px $blue-primary);
    }

    .text {
      color: #c0e4ff !important;

      span {
        color: $blue-primary !important;
        text-shadow: $text-glow;
      }
    }
  }

  .footer-right {
    .service {
      .title {
        color: $blue-primary !important;
        text-shadow: $text-glow;
      }

      .list {
        .li {
          color: #c0e4ff !important;

          &:hover {
            color: $blue-primary !important;
            text-shadow: $text-glow;
          }
        }
      }
    }

    .contact {
      .title {
        color: $blue-primary !important;
        text-shadow: $text-glow;
      }

      .item {
        color: #c0e4ff !important;

        img {
          filter: brightness(1.2) drop-shadow(0 0 5px $blue-primary);
        }
      }
    }

    .qrcode {
      border: 1px solid $blue-primary !important;
      box-shadow: 0 0 20px $blue-glow;
    }
  }

  // 其他网站区域
  .other-site {
    border-top: 1px solid rgba(27, 168, 232, 0.3) !important;
    margin-top: 30px !important;
    padding-top: 30px !important;

    .other-site-title {
      color: $blue-primary !important;
      font-size: 18px !important;
      font-weight: bold !important;
      margin-bottom: 15px !important;
      text-shadow: $text-glow;
      position: relative;
      display: inline-block;

      &::after {
        content: '';
        position: absolute;
        bottom: -5px;
        left: 0;
        width: 50px;
        height: 2px;
        background: $blue-primary;
        box-shadow: 0 0 10px $blue-primary;
      }
    }

    .other-site-links {
      display: flex !important;
      flex-wrap: wrap !important;
      gap: 15px !important;
      margin-bottom: 20px !important;

      .other-site-link-item {
        color: #c0e4ff !important;
        font-size: 14px !important;
        padding: 5px 15px !important;
        border: 1px solid rgba(27, 168, 232, 0.2) !important;
        border-radius: 20px !important;
        transition: all 0.3s ease !important;
        cursor: pointer !important;

        &:hover {
          border-color: $blue-primary !important;
          box-shadow: 0 0 15px $blue-glow !important;
          color: $blue-primary !important;
          transform: translateY(-2px);
        }
      }
    }

    .other-site-copyright {
      color: #c0e4ff !important;
      font-size: 13px !important;
      line-height: 1.8 !important;
      text-align: center !important;

      a {
        color: $blue-primary !important;
        text-decoration: none !important;
        transition: all 0.3s ease !important;

        &:hover {
          color: lighten($blue-primary, 20%) !important;
          text-shadow: $text-glow;
        }
      }

      .icp {
        color: #c0e4ff !important;
        margin: 0 5px;

        span {
          color: $blue-primary !important;
        }
      }

      .beian {
        color: #c0e4ff !important;
        margin: 0 5px;

        a {
          color: $blue-primary !important;
        }
      }

      .company {
        color: $blue-primary !important;
        font-weight: bold;
      }
    }
  }
}

// 响应式调整
@media screen and (max-width: 1200px) {
  .pages {
    .box {
      padding: 30px 40px;

      li {
        span:nth-child(1) {
          font-size: 18px;
        }

        span:nth-child(2) {
          font-size: 16px;
        }

        .imgs {
          img {
            width: 160px;
            height: 120px;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .pages {
    .box {
      padding: 20px;

      li {
        span:nth-child(1) {
          font-size: 16px;
        }

        span:nth-child(2) {
          font-size: 14px;
        }

        .imgs {
          img {
            width: 100%;
            max-width: 100%;
            height: auto;
          }
        }
      }
    }
  }
}
</style>